(() => {
  const start = Date.parse('2026-10-01T00:00:00-03:00');
  const end = Date.parse('2026-10-08T00:00:00-03:00');
  function updateCampaign() {
    const active = Date.now() >= start && Date.now() < end;
    document.querySelectorAll('[data-cyber]').forEach(node => { node.hidden = !active; });
    document.querySelectorAll('[data-cyber-regular]').forEach(node => { node.hidden = active; });
  }
  updateCampaign();
  setInterval(updateCampaign, 1000);
  document.addEventListener('visibilitychange', updateCampaign);
  document.addEventListener('shopify:section:load', updateCampaign);
})();
